<template>
  <div class="card-info-cliente-pedido">
    <!-- <div class="titulo-fluxos"> INFORMAÇÕES DO CLIENTE </div>
    <div class="subtitulo-fluxos"> Confirme as informações do cliente antes de continuar. </div> -->

    <g-titulo-steps
    titulo="INFORMAÇÕES DO CLIENTE"
    subtitulo="Confirme as informações do cliente antes de continuar."
    :imagemEmpresa = imagemEmpresa
    />
      
    <div class="header-infoCliente-btnEditar">
      <g-button
      class="btn-editar"
      altura="35px"
      largura="35px"
      tamanhoIcone="20px"
      icone="icone_editar.svg"
      @click="abrePopup"
      >
      </g-button>
    </div>

    <div class="header-infoCliente-conteudo espacamento-fluxos">
      <div class="cliente-cnpj">
        <div class="titulo-conteudo-fluxos"> CNPJ </div>
        <PInputText 
          class="cnpj-input input-label"
          disabled 
          :value="this.objForm.cnpj"
        />
      </div>

      <div class="cliente-codigo">
        <div class="titulo-conteudo-fluxos"> Código </div>
        <PInputText 
          class="codigo-input input-label" 
          disabled
          :value="this.objForm.codigo"
        />
      </div>

      <div class="cliente-razao-social">
        <div class="titulo-conteudo-fluxos"> Razão Social </div>
        <PInputText 
          class="razao-social-input input-label" 
          disabled
          :value="this.objForm.razaoSocial"
        />
      </div>

      <div class="cliente-estado">
        <div class="titulo-conteudo-fluxos"> Estado </div>
        <PInputText 
          class="estado-input input-label" 
          disabled
          :value="this.objForm.siglaEstado"
        />
      </div>

      <div class="cliente-cidade">
        <div class="titulo-conteudo-fluxos"> Cidade </div>
        <PInputText 
          class="cidade-input input-label" 
          disabled
          :value="this.objForm.nomeCidade"
        />
      </div>

      <div class="cliente-segmento">
        <div class="titulo-conteudo-fluxos"> Segmento </div>
        <PInputText 
          class="segmento-input input-label" 
          disabled
          :value="this.objForm.clienteTipoTexto"
        />
      </div>

      <div class="cliente-contato">
        <div class="titulo-conteudo-fluxos"> Contato </div>
        <PInputText 
          class="contato-input input-label" 
          disabled
          :value="this.objForm.nomeContato"
        />
      </div>

      <div class="cliente-telefone">
        <div class="titulo-conteudo-fluxos"> Telefone </div>
        <PInputText 
          class="telefone-input input-label" 
          disabled
          :value="this.objForm.numeroTelefone == 0 ? '-' : this.objForm.numeroTelefone"
        />
      </div>

      <div class="cliente-ramal">
        <div class="titulo-conteudo-fluxos"> Ramal </div>
        <PInputText 
          class="ramal-input input-label" 
          disabled
          :value ="this.objForm.numeroRamal == 0 ? '-' : this.objForm.numeroRamal"  
        />
      </div>

      <div class="cliente-suframa">
        <div class="titulo-conteudo-fluxos"> Suframa </div>
        <PInputText 
          class="suframa-input input-label" 
          disabled
          :value="this.objForm.numeroSuframa == null ? '-' : this.objForm.numeroSuframa"
        />
      </div>

      <div class="cliente-incentivo-fiscal">
        <div class="incentivo-fiscal-titulo titulo">
           <label class="incentivo-input input-label">Possui incentivo fiscal?</label>
            <PInputText :value="this.ICMS + this.IPI + this.PisCofins == '' ? 'NÃO' : this.ICMS + this.IPI + this.PisCofins" disabled></PInputText>
        </div>    
      </div> 
    </div>

    <div class="buttons-next-back">
      <div class="button-next">
        <g-button 
        tipo="amarelo"
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="Continuar()"
        > 
          CONTINUAR 
        </g-button>
      </div>
      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="Voltar()"
        > 
          VOLTAR 
        </g-button>
      </div>
    </div>

    <div class="editar-cliente">
      <PDialog :showHeader=false :closable="false" v-model:visible="popup" :modal="true" >
        <div class="titulo-popup-finalizado"> Deseja editar as informações do cliente? </div>
        <div class="botoes-popup">
          <div>
            <g-button 
            tipo="cinza"
            negritoTexto 
            largura="200px" 
            altura="35px" 
            @click="fechaPopup"
            > 
              NÃO 
            </g-button>
          </div>
          <div>
            <g-button 
            tipo="amarelo"
            negritoTexto
            largura="200px" 
            altura="35px" 
            @click="modificar"
            > 
              SIM 
            </g-button>
          </div>
        </div>
      </PDialog>
    </div>

    <PDialog :showHeader=false :closable="false" v-model:visible="popupCompletarCadastroCliente" :modal="true" >
      <div class="popup-container-completar-cadastro">
        <div class="titulo-popup-finalizado"> É necessário finalizar o cadastro do cliente para continuar </div>
        <div class="botoes-popup">
          <div>
            <g-button 
            tipo="cinza"
            negritoTexto 
            largura="200px" 
            altura="35px" 
            @click="fechaPopupCadastroCliente"
            > 
              Cancelar 
            </g-button>
          </div>
          <div>
            <g-button 
            tipo="amarelo"
            negritoTexto
            largura="200px" 
            altura="35px"
            @click="redirecionaFichaCadastral"
            > 
              Continuar 
            </g-button>
          </div>
        </div>
      </div>
    </PDialog>
  </div>
</template>

<script>
import InfoCliente from './InfoCliente.js'
export default InfoCliente
</script>

<style scoped>

.header-infoCliente {
  display: flex;
}

.header-infoCliente-titulo-subtitulo {
  width: 100%;
}

.header-infoCliente-btnEditar {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.header-infoCliente-titulo {
  color:#4F2C19;
  text-align: center;
  font-family: "MontSerrat";
  font-weight: bold;
}
.p-inputtext {
    margin: 0;
    width: 100%;
}
.header-infoCliente-subtitulo {
  color:#868686;
  text-align: center;
  font-family: 'MontSerrat';
}

.titulo {
  width: 100%;
  color: #3e3e3e;
  text-align: left;
  font-size: 15px;
  font-family: 'MontSerrat';
  font-weight: 600;
  font-weight: bold;
  margin: 0 0 1px;
}

.incentivo-fiscal-titulo {
  margin-left: 5px;
}

.input-label {
  width: 100%;
}

.conteudo-popup-edicao {
  font-size: 18px;
  font-weight: 600;
}

.popup-container-completar-cadastro[data-v-6fddcfc0] {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding-top: 1rem;
}

.conteudo-popup-edicao {
  width: 80%;
  text-align: center;
}

.editar-informacoes-cliente {
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  width: 80%;
}

@media (min-width:310px) {
  .btn-voltar{
    width: 90%;
  }

  .btn-continuar{
    width: 90%;
  }
.header-infoCliente-conteudo {
  display: grid;
  grid-template-columns: minmax(4em, 1fr);
  grid-template-rows: repeat(11, auto);
  grid-column-gap: 20px;
  grid-row-gap: 14px;
}

.header-infoCliente-titulo { font-size: 18px; }

.header-infoCliente-subtitulo { font-size: 16px; }

.btnAvancarVoltar {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column-reverse;
  column-gap: 50px;
  row-gap: 15px;
}
}

@media (min-width:368px) {
  .btn-voltar{
    width: 100%;
  }

  .btn-continuar{
    width: 100%;
  }
.header-infoCliente-conteudo {
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(8, auto);
}
.cliente-cnpj { grid-area: 1 / 1 / 2 / 3; }
.cliente-codigo { grid-area: 2 / 1 / 3 / 3; }
.cliente-razao-social { grid-area: 3 / 1 / 4 / 3; }
.cliente-estado { grid-area: 4 / 1 / 5 / 2; }
.cliente-cidade { grid-area: 4 / 2 / 5 / 3; }
.cliente-segmento { grid-area: 5 / 1 / 6 / 2; }
.cliente-contato { grid-area: 5 / 2 / 6 / 3; }
.cliente-telefone { grid-area: 6 / 1 / 7 / 3; }
.cliente-ramal { grid-area: 7 / 1 / 8 / 2; }
.cliente-suframa { grid-area: 7 / 2 / 8 / 3; }
.cliente-incentivo-fiscal { grid-area: 8 / 1 / 9 / 3; }
}

@media (min-width:600px) {
.header-infoCliente-titulo { font-size: 20px; }

.header-infoCliente-subtitulo { font-size: 18px; }

.header-infoCliente-conteudo {
  grid-template-rows: repeat(7, auto);
}
.cliente-cnpj { grid-area: 1 / 1 / 2 / 2; }
.cliente-codigo { grid-area: 1 / 2 / 2 / 3; }
.cliente-razao-social { grid-area: 2 / 1 / 3 / 3; }
.cliente-estado { grid-area: 3 / 1 / 4 / 2; }
.cliente-cidade { grid-area: 3 / 2 / 4 / 3; }
.cliente-segmento { grid-area: 4 / 1 / 5 / 2; }
.cliente-contato { grid-area: 4 / 2 / 5 / 3; }
.cliente-telefone { grid-area: 5 / 1 / 6 / 2; }
.cliente-ramal { grid-area: 5 / 2 / 6 / 3; }
.cliente-suframa { grid-area: 6 / 1 / 7 / 2; }
.cliente-incentivo-fiscal { grid-area: 6 / 2 / 7 / 3; align-self: center; }

.btnAvancarVoltar {
  flex-direction: row;
  column-gap: 20px;
}
}

@media (min-width:801px) {

}

@media (min-width:1025px) { 
  .btnAvancarVoltar{
    width: 100%;
      display: flex;
      align-items: baseline;
      gap: 15px;
      padding: 2rem 14rem 1.5rem 14rem;
  }
.header-infoCliente-titulo { font-size: 22px; }

.header-infoCliente-subtitulo { font-size: 20px; }

.header-infoCliente-btnEditar { padding: 0 50px; }

.header-infoCliente-conteudo {
  grid-template-columns: repeat(6, minmax(4em, 1fr));
  grid-template-rows: repeat(3, auto);
}

.cliente-cnpj { grid-area: 1 / 1 / 2 / 3; }
.cliente-codigo { grid-area: 1 / 3 / 2 / 5; }
.cliente-razao-social { grid-area: 1 / 5 / 2 / 7; }
.cliente-estado { grid-area: 2 / 1 / 3 / 2; }
.cliente-cidade { grid-area: 2 / 2 / 3 / 3; }
.cliente-segmento { grid-area: 2 / 3 / 3 / 5; }
.cliente-contato { grid-area: 2 / 5 / 3 / 7; }
.cliente-telefone { grid-area: 3 / 1 / 4 / 3; }
.cliente-ramal { grid-area: 3 / 3 / 4 / 4; }
.cliente-suframa { grid-area: 3 / 4 / 4 / 5; }
.cliente-incentivo-fiscal { grid-area: 3 / 5 / 4 / 7; align-self: center; }
}

@media (min-width:1281px) { 
.btnAvancarVoltar{
  padding: 2rem 20rem 1.5rem 20rem;
}

.header-infoCliente-btnEditar { padding: 0 130px; }
}

@media (min-width:1500px) { 

.header-infoCliente-btnEditar { padding: 0 150px; }
}
</style>
